import { render, staticRenderFns } from "./FiscalDataTab.vue?vue&type=template&id=468277ba&scoped=true"
import script from "./FiscalDataTab.vue?vue&type=script&lang=js"
export * from "./FiscalDataTab.vue?vue&type=script&lang=js"
import style0 from "./FiscalDataTab.vue?vue&type=style&index=0&id=468277ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468277ba",
  null
  
)

export default component.exports